import React from 'react';
import './index.css';
import { BrowserRouter,Routes, Route } from 'react-router-dom';
import Login from './pages/Login/Tela-login';
import Recuperar from './pages/Redefinir/Tela-redefinir';
import Registro from './pages/Registro/registro';
import NotFound from './pages/NotFound/notFound';

function App() {
  return (
    <BrowserRouter>
      <Routes>

      <Route path="/" element={<Login />} />

      <Route path="/redefinir" element={<Recuperar />} />

      <Route path='/registro' element={<Registro />} />

      <Route path="*" element={<NotFound />} /> 
      
      </Routes>
    </BrowserRouter>
  );
}

export default App;
